export const HIGHLIGHT_CONTAINER_CLASS = 'highlight-container';
export const HIGHLIGHT_CONTAINER_HOVERED_CLASS = 'highlight-container--hovered';
